import { Checkbox, Tooltip } from "@xola/ui-kit";
import React, { ChangeEvent } from "react";

interface ChargeCreditCardCheckboxProps {
    checked?: boolean;

    onChange: (value: boolean) => void;
}

export const ChargeCreditCardCheckbox = ({ checked, onChange }: ChargeCreditCardCheckboxProps) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    return (
        <Tooltip
            content="Checking this box lets you accept this booking now, but charge the customer's credit card at a later time"
            placement="auto"
        >
            <Checkbox label="Do not charge credit card now" checked={checked} onChange={handleChange} />
        </Tooltip>
    );
};
